import { createResourceStore } from '@/stores/resource';
import type { Sku } from '@shared/inventory';

export const useSkusStore = createResourceStore<Sku>('skus', '/api/skus');
